import { Link } from "react-router-dom";
import { Stethoscope, Mail, Instagram, MessageCircle, Facebook, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-ink text-paper-50 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <span className="flex items-center justify-center w-9 h-9 rounded-sm bg-scholar text-ink">
              <Stethoscope className="w-5 h-5" strokeWidth={2.2} />
            </span>
            <span className="font-display font-black text-lg tracking-tight leading-none">
              The STEM Vet<span className="text-terracotta">.</span>
            </span>
          </div>
          <p className="mt-5 max-w-md text-paper-200/80 leading-relaxed">
            Empowering first-gen and non-traditional students to master STEM, ace the MMI,
            and write admission essays that sound like them, not a template.
          </p>
          <div className="flex items-center gap-3 mt-6">
            <a href="mailto:ashleydelmar04@gmail.com" className="w-10 h-10 rounded-sm bg-paper-50/10 hover:bg-scholar hover:text-ink flex items-center justify-center transition-colors" data-testid="footer-social-email" aria-label="Email">
              <Mail className="w-4 h-4" />
            </a>
            <a href="https://wa.me/48516736168" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-sm bg-paper-50/10 hover:bg-scholar hover:text-ink flex items-center justify-center transition-colors" data-testid="footer-social-whatsapp" aria-label="WhatsApp">
              <MessageCircle className="w-4 h-4" />
            </a>
            <a href="https://www.instagram.com/thestemvet/" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-sm bg-paper-50/10 hover:bg-scholar hover:text-ink flex items-center justify-center transition-colors" data-testid="footer-social-instagram" aria-label="Instagram">
              <Instagram className="w-4 h-4" />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61588789805221" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-sm bg-paper-50/10 hover:bg-scholar hover:text-ink flex items-center justify-center transition-colors" data-testid="footer-social-facebook" aria-label="Facebook">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="https://www.linkedin.com/in/ashley-delmar-a75a8b2a5/" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-sm bg-paper-50/10 hover:bg-scholar hover:text-ink flex items-center justify-center transition-colors" data-testid="footer-social-linkedin" aria-label="LinkedIn">
              <Linkedin className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-scholar">Explore</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/about" className="hover:text-scholar transition-colors" data-testid="footer-link-about">About Dr. Delmar</Link></li>
            <li><Link to="/services" className="hover:text-scholar transition-colors" data-testid="footer-link-services">Services</Link></li>
            <li><Link to="/blog" className="hover:text-scholar transition-colors" data-testid="footer-link-blog">Blog</Link></li>
            <li><Link to="/contact" className="hover:text-scholar transition-colors" data-testid="footer-link-contact">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="overline text-scholar">Get Started</p>
          <p className="mt-4 text-sm text-paper-200/80">
            Ready to turn the volume down on overwhelm? Reach out and we'll map your next 4 weeks together.
          </p>
          <Link
            to="/contact"
            data-testid="footer-cta-start"
            className="mt-5 inline-flex items-center gap-2 bg-terracotta text-paper-50 px-5 py-2.5 text-sm font-semibold rounded-sm hover:bg-terracotta-dark hover:-translate-y-0.5 transition-all"
          >
            Book your intro call →
          </Link>
        </div>
      </div>
      <div className="border-t border-paper-50/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-paper-200/60">
          <p>© {new Date().getFullYear()} The STEM Vet. All rights reserved.</p>
          <p>Crafted with care for first-gen scholars.</p>
        </div>
      </div>
    </footer>
  );
}
